const baseUrl =
  process.env.NODE_ENV === "production"
    ? "https://intranet-gac-production.up.railway.app/v1/api"
    : "https://intranet-gac-production.up.railway.app/v1/api";

const baseUrlCloudinary = "https://media-upload-gac-production.up.railway.app";

export { baseUrl, baseUrlCloudinary };
